'use strict';

angular.module('atex.aceui.service').factory('ImageMetadataService',
  ['$q', '$rootScope', 'ApplicationConfigurationService',

    function($q, $rootScope, ApplicationConfigurationService) {
      var serviceHandler = undefined;

      var handler = function() {
        if (serviceHandler !== undefined) {
          return $q.when(serviceHandler);
        }

        return ApplicationConfigurationService.getServiceConfigurationFor('ImageMetadataService').then(function(configuration) {
          var serviceUrl = atex.aceui.ServiceUtils.calculateServiceUrl(configuration, '/image-metadata-extractor-service');

          var serviceSettings = { customQ: atex.aceui.AngularUtils.applyingQ($q, $rootScope) };
          serviceHandler = atex.aceui.service.ImageMetadataService(serviceUrl, serviceSettings);

          return serviceHandler;
        });
      };

      return {
        /**
         * Wraps atex.aceui.service.ImageMetadataService.getImageMetadata with service configuration.
         *
         * See documentation for atex.aceui.service.ImageMetadataService.getImageMetadata.
         */
        getImageMetadata: function(transferInfo) {
          return handler().then(function(serviceHandler) {
            return serviceHandler.getImageMetadata(transferInfo);
          });
        }
      };
    }
  ]);